__turbopack_context__.v({
  "sponsorship_franchise_row": "W41Lla_sponsorship_franchise_row",
});
